export const state = {
  customerContract: null,
  attachments: [],
}

export const mutations = {
  SET_CUSTOMER_CONTRACT(state, payload) {
    state.customerContract = payload
  },
  SET_ATTACHMENTS(state, payload) {
    state.attachments = payload
  },
}

export const getters = {
  customerContractStatusName(state) {
    return state.customerContract?.status?.name
  },
  hasTrackLink(state) {
    return state.customerContract?.track_link
  },
  contractNumber(state) {
    return state.customerContract?.number
  },
}
